module.exports = {
	MODE_NUMBER :		1 << 0,
	MODE_ALPHA_NUM : 	1 << 1,
	MODE_8BIT_BYTE : 	1 << 2,
	MODE_KANJI :		1 << 3
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/qr.js/lib/mode.js
 ** module id = 640
 ** module chunks = 0
 **/